import React from 'react';
import { withRouter } from 'react-router-dom';

import API from '../tools/API.jsx';
import SubmissionDetail from '../views/retriever/SubmissionDetail.jsx';
import Localization from "../Localization.jsx";

import { Grid, Typography, CircularProgress, Card, CardContent, Icon } from '@mui/material';

class SharedSubmissionPage extends React.Component {
  constructor(props) {
    super(props);
    this.api = new API();
    this.submissionDetailRef = React.createRef();
    this.state = {
      loading: true,
      error: null,
      submissionData: null,
      localeData: null,
      scoreData: null,
    };
  }

  componentDidMount() {
    const { shareToken } = this.props.match.params;
    if (shareToken) {
      this.api.request("get_submission_by_token", { token: shareToken }, this.getTokenOK, this.getTokenFailed);
    } else {
      this.setState({ loading: false, error: "No sharing token provided." });
    }
  }

  getTokenOK = (res) => {
    if (res.body.result && typeof res.body.result === 'object' && Object.keys(res.body.result).length > 0) {
      const submissionData = res.body.result;
      this.setState({ submissionData, loading: false }, () => {
        if (this.submissionDetailRef.current) {
          // Pass the submission ID to SubmissionDetail and refresh it
          this.submissionDetailRef.current.setState({ submissionId: submissionData.id }, () => {
            this.submissionDetailRef.current.refresh();
          });
        }
        // The locale name and score arrive WITH the token response now. They
        // used to be two extra calls to get_epacks_by_ids / get_submission_score,
        // but those map to bearer-gated routes — and this page is opened by
        // people with no account, which is the whole point of a share link. The
        // token endpoint bundles them so nothing here needs a session.
        if (submissionData.locale) {
          this.setState({ localeData: submissionData.locale });
        }
        if (submissionData.score) {
          this.setState({ scoreData: submissionData.score });
        }
      });
    } else {
      this.setState({ loading: false, error: "Submission not found or the link is invalid." });
    }
  }

  getScoreOK = (res) => {
    if (res && res.body && res.body.result) {
      this.setState({ scoreData: res.body.result });
    }
  }

  getScoreFailed = (err) => {
    // Silently ignore score errors on shared page
    console.error("Get submission score failed", err);
  }

  getLocaleOK = (res) => {
    if (res.body.result && Array.isArray(res.body.result) && res.body.result.length > 0) {
      this.setState({ localeData: res.body.result[0] });
    } else {
      console.error("Locale not found or invalid response.");
    }
  }

  getLocaleFailed = (err) => {
    console.error("Get locale by ID failed", err);
  }

  getTokenFailed = (err) => {
    console.error("Get submission by token failed", err);
    // GET /api/submission/byToken is a BEARER route on the new surface (the
    // legacy cmd was anonymous), so a share link opened by someone who is not
    // signed in now 401s. Say so instead of blaming the link.
    // No 401 branch any more: /api/submission/byToken is public — the share
    // token IS the credential — so an auth failure here is not an expected case.
    const error = "An error occurred while fetching the submission. Please try again later.";
    this.setState({ loading: false, error: error });
  }

  render() {
    const { loading, error, submissionData, localeData, scoreData } = this.state;

    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', padding: '20px' }}>
          <Card>
            <CardContent style={{ textAlign: 'center' }}>
              <Icon style={{ fontSize: 48, color: 'red', marginBottom: '16px' }}>error_outline</Icon>
              <Typography variant="h5" component="h2">
                Error
              </Typography>
              <Typography color="textSecondary">
                {error}
              </Typography>
            </CardContent>
          </Card>
        </div>
      );
    }

    // Mock props for SubmissionDetail to match what it expects from RootPage
    const mockRoot = {
      refs: { API: this.api },
      addNotification: (msg, isSuccess) => console.log(`[Notification] ${msg} (Success: ${isSuccess})`),
      // The shared page has no user privileges, so we return a "disabled" value.
      getPrivilege: (privilegeName) => {
        console.log(`[Privilege Check] Suppressing privilege: ${privilegeName}`);
        return { value: '0' };
      },
      // Add other methods/properties that SubmissionDetail might need in the future
    };
    
    return (
      <div style={{ marginTop: '20px', padding: '0 1%' }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              {localeData ? localeData.name : 'Loading...'}
            </Typography>
            <Typography variant="h5" gutterBottom>
              {Localization.strings.SUBMISSION_BY} {submissionData.user_name}
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {Localization.strings.SUBMITTED_ON} {submissionData.submission_time}
            </Typography>
            {scoreData && typeof scoreData.score !== 'undefined' && typeof scoreData.score_max !== 'undefined' && Number(scoreData.score) >= 0 && Number(scoreData.score_max) >= 0 && (
              <Typography variant="h6" gutterBottom>
                Score: {scoreData.score} / {scoreData.score_max}
              </Typography>
            )}
            <div style={{ paddingTop: '12px' }}>
              <SubmissionDetail
                ref={this.submissionDetailRef}
                parent={this}
                root={mockRoot}
                isSharedView={true}
                shareToken={this.props.match.params.shareToken}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(SharedSubmissionPage); 